import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawDraftIcon from "./RawDraftIcon.svg.jsx";

const DraftIcon = forwardRef((props, ref) => {
  return (
    <Icon ref={ref} SvgComponent={RawDraftIcon} title="Draft icon" {...props} />
  );
});

DraftIcon.displayName = "DraftIcon";
export default DraftIcon;
